module.exports = __webpack_public_path__ + "img/title@2x.0bdf6347.png";